// @flow
import React from "react";
import { FormGroup } from "reactstrap";
import { connect } from "react-redux";
import * as Constants from "../../../../constants/photoDimensions";
import ImageField from "../../../components/ImageField";
import { updateField } from "../../../../redux/actions/configActions";
import Section from "../../../components/Section";

const mapDispatchToProps = { updateField };
const mapStateToProps = state => {
  const { configReducer } = state;
  return {
    config: configReducer.config,
    files: configReducer.files
  };
};

class GreenScreenSettings extends React.Component {
  constructor(props) {
    super(props);

    // #region event binders
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleValidatedFileChange = this.handleValidatedFileChange.bind(this);
    // #endregion
  }
  // #region events

  handleChange(event) {
    this.props.updateField({ [event.target.name]: event.target.value });
  }

  handleCheckboxChange(event) {
    event.persist();
    const { config, files } = this.props;
    this.props.updateField({
      [event.target.name]: !config[event.target.name]
    });
  }

  handleValidatedFileChange(id, image) {
    this.props.updateField({ [id]: image });
  }

  // #endregion
  render() {
    const { config, files } = this.props;

    return (
      <React.Fragment>
        <Section title="Green screen settings" subsection>
          <FormGroup row>
            <ImageField
              id="greenScreenBackground1"
              label="GS Background 1"
              required
              image={files.greenScreenBackground1File}
              width={
                config.photoRatio == 1
                  ? Constants.PictureWidth
                  : Constants.PictureHeight
              }
              height={
                config.photoRatio == 1
                  ? Constants.PictureHeight
                  : Constants.PictureWidth
              }
              onDeleteChange={this.handleCheckboxChange}
              onFileChange={this.handleValidatedFileChange}
            />
          </FormGroup>
          <FormGroup row>
            <ImageField
              id="greenScreenBackground2"
              label="GS Background 2"
              required={false}
              image={files.greenScreenBackground2File}
              width={
                config.photoRatio == 1
                  ? Constants.PictureWidth
                  : Constants.PictureHeight
              }
              height={
                config.photoRatio == 1
                  ? Constants.PictureHeight
                  : Constants.PictureWidth
              }
              onDeleteChange={this.handleCheckboxChange}
              onFileChange={this.handleValidatedFileChange}
            />
          </FormGroup>
          <FormGroup row>
            <ImageField
              id="greenScreenBackground3"
              label="GS Background 3"
              required={false}
              image={files.greenScreenBackground3File}
              width={
                config.photoRatio == 1
                  ? Constants.PictureWidth
                  : Constants.PictureHeight
              }
              height={
                config.photoRatio == 1
                  ? Constants.PictureHeight
                  : Constants.PictureWidth
              }
              onDeleteChange={this.handleCheckboxChange}
              onFileChange={this.handleValidatedFileChange}
            />
          </FormGroup>
        </Section>
      </React.Fragment>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GreenScreenSettings);



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/config-form-subsections/GreenScreenSettings.jsx